/* Private */

const getNavItem = (
	title,
	route,
	routeName,
	iconComponent,
	suffixComponent,
	suffixComponentProps,
	suffixComponentClass,
	openInNewTab,
	requiredAccountPermission,
	featureFlag
) => ({
	title,
	route,
	routeName,
	iconComponent,
	suffixComponent,
	suffixComponentProps,
	suffixComponentClass,
	openInNewTab,
	requiredAccountPermission,
	featureFlag,
});

/* Public */
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import AlertsSVG from './assets/AlertsSVG';
import AnalyticsSVG from './assets/AnalyticsSVG';
import AutomationsSVG from './assets/AutomationsSVG';
import BillingUsageIcon from './assets/BillingUsageIcon';
import ConnectionsSVG from './assets/ConnectionsSVG';
import CustomerFeaturesSVG from './assets/CustomerFeaturesSVG';
import HomeSVG from './assets/HomeSVG';
import IssuesSVG from './assets/IssuesSVG';
import LearnSVG from './assets/LearnSVG';
import SubflowsSVG from './assets/SubflowsSVG';
import TaskLogSVG from './assets/TaskLogSVG';
import TeamFeaturesSVG from './assets/TeamFeaturesSVG';
import InboxSettingsMenu from '@/components/Inbox/InboxSettingsMenu.vue';
import InboxService from '@/components/Inbox/inbox-service';
/* Accordions related */
import { staticInboxes } from '@/components/Inbox/inbox.const';
import AppPendingAlerts from '@/components/common/AppPendingAlerts.vue';
import InboxPendingAlerts from '@/components/common/InboxPendingAlerts.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { BILLING_USAGE_ROUTE_NAME } from '@/router/BillingUsage/billing-usage-router.const';
import {
	INBOX_ROUTE_NAME,
	LEARN_ROUTE_NAME,
	ANALYTICS_ROUTE_NAME,
	TASK_LOG_ROUTE_NAME,
	ISSUES_ROUTE_NAME,
	CUSTOMER_FEATURES_ROUTE_NAME,
	AUTOMATIONS_ROUTE_NAME,
	TEAM_FEATURES_ROUTE_NAME,
	SUBFLOWS_ROUTE_NAME,
	GETTING_STARTED_ROUTE_NAME,
	CONNECTIONS_ROUTE_NAME_ROOT,
} from '@/router/router.const';
import { FEATURE_FLAGS } from '@/utils/feature-toggle-service';
export const PRIMARY_NAVIGATION_ITEMS = [
	getNavItem('Home', '/getting-started', GETTING_STARTED_ROUTE_NAME, HomeSVG),
	getNavItem('Team features', '/team-features', TEAM_FEATURES_ROUTE_NAME, TeamFeaturesSVG),
	getNavItem('Customer features', '/customer-features', CUSTOMER_FEATURES_ROUTE_NAME, CustomerFeaturesSVG),
	getNavItem('Automations', '/automations', AUTOMATIONS_ROUTE_NAME, AutomationsSVG),
	getNavItem('divider'),
	getNavItem('Connections', '/connections', CONNECTIONS_ROUTE_NAME_ROOT, ConnectionsSVG),
	getNavItem('Analytics', '/analytics', ANALYTICS_ROUTE_NAME, AnalyticsSVG),
	getNavItem('Issues', '/issues', ISSUES_ROUTE_NAME, IssuesSVG),
	getNavItem('Subflows', '/subflows', SUBFLOWS_ROUTE_NAME, SubflowsSVG),
	getNavItem('Task log', '/task-log', TASK_LOG_ROUTE_NAME, TaskLogSVG),
];

export const getInboxNavItem = ({ useInboxesGetter, fetchInboxesAction }) => ({
	title: 'Notifications',
	titleSuffixComponent: {
		class: 'ml-2',
		component: AppPendingAlerts,
	},
	additionalItemSuffix: {
		class: 'mr-1',
		component: InboxPendingAlerts,
	},
	sections: [
		{ title: null, getItemsFunc: () => staticInboxes },
		{ title: 'Team inboxes', getItemsFunc: () => useInboxesGetter },
	],
	settings: {
		component: InboxSettingsMenu,
		hasPermissionToEditSettingsFunc: InboxService.hasPermissionToEditInbox,
	},
	createNewConfig: {
		tooltipText: 'Create new inbox',
		createNew: AppDialogManagerService.openInboxDialog,
	},
	collapsedModeNavButtonItem: {
		title: 'Notifications',
		iconComponent: AlertsSVG,
		routeName: INBOX_ROUTE_NAME,
		suffixComponent: AppPendingAlerts,
		suffixComponentProps: { pad: true, minimized: true },
		suffixComponentClass: { 'always-show': true, 'mt-n2': true },
	},
	to: ({ id }) => ({ name: INBOX_ROUTE_NAME, params: { inboxId: id } }),
	requiredAction: fetchInboxesAction,
});

export const getAccordionNavItems = ({ useInboxesGetter, fetchInboxesAction }) => [
	getInboxNavItem({ useInboxesGetter, fetchInboxesAction }),
];

export const SECONDARY_NAVIGATION_ITEMS = [
	getNavItem(
		'Billing & usage',
		'/usage',
		BILLING_USAGE_ROUTE_NAME,
		BillingUsageIcon,
		null,
		null,
		null,
		null,
		AccountPermissions.ViewBilling,
		FEATURE_FLAGS.SHOW_BILLING_USAGE
	),
	getNavItem('Learn', '/learn', LEARN_ROUTE_NAME, LearnSVG),
];
